import EmblaCarousel from 'embla-carousel'

export const baseProps = {
  vertical: {
    type: Boolean,
    default: false
  },
  slidesPerView: {
    type: [Number, Object],
    default: 4
  }
}

export const emblaProps = {
  align: {
    type: String,
    default: 'start'
  },
  slidesToScroll: {
    type: Number,
    default: 1
  },
  containScroll: {
    type: String,
    default: 'trimSnaps'
  },
  draggable: {
    type: Boolean,
    default: true
  },
  dragFree: {
    type: Boolean,
    default: false
  },
  loop: {
    type: Boolean,
    default: false
  },
  speed: {
    type: Number,
    default: 10
  },
  startIndex: {
    type: Number,
    default: 0
  },
  inViewThreshold: {
    type: Number,
    default: 0.5
  }
}

export const props = {
  ...baseProps,
  ...emblaProps
}

const parseOptions = (ctx) => {
  const axis = ctx.vertical ? 'y' : 'x'
  const opts = Object.keys(emblaProps).reduce((options, prop) => {
    options[prop] = ctx[prop]
    return options
  }, { axis })

  return opts
}

export const createCarousel = (ctx, el, config) => {
  const options = parseOptions(ctx)
  return EmblaCarousel(el, { ...options, ...config })
}

export const reInitCarousel = (ctx, config) => {
  const options = parseOptions(ctx)
  ctx.call('reInit', { ...options, ...config })
}

export const autoplay = (embla, interval) => {
  let timer = 0

  const play = () => {
    stop()
    requestAnimationFrame(() => timer = window.setTimeout(next, interval))
  }

  const stop = () => {
    window.clearTimeout(timer)
    timer = 0
  }

  const next = () => {
    if (embla.canScrollNext()) {
      embla.scrollNext()
    } else {
      embla.scrollTo(0)
    }

    play()
  }

  return { play, stop }
}
